var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tw-flex-shrink-0 tw-px-1.5 disabled:tw-opacity-50",class:{'tw-cursor-pointer': _vm.isButtonDisabled,
   'searchResult_nextDayItinerary': _vm.isArrowNextLink,
   'searchResult_prevDayItinerary' : !_vm.isArrowNextLink},attrs:{"disabled":_vm.isButtonDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{class:_vm.computedImageClass,attrs:{"src":require('@/assets/icons/arrow-right.svg'),"alt":`Arrow ${_vm.arrowType}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }